import { IWorkflowValidator } from '@modules/campaigns/Domain/Interfaces/IWorkflowValidator';
import { ValidationError } from '@modules/campaigns/Domain/Enums/ValidationErrors';
import { IWorkflow } from '@modules/campaigns/Domain/Interfaces/IWorkflow';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { WorkflowType } from '@modules/campaigns/Domain/Enums/WorkflowType';

const CONDITIONAL_TYPES = new Set([
  NodeType.Conditional,
  NodeType.ConditionalSegments,
  NodeType.Experiment,
]);

export class NodesHaveChildValidator implements IWorkflowValidator {
  validate(workflow: IWorkflow): string[] {
    const errors: string[] = [];
    let hasNoChild = false;
    let hasMissingBranch = false;

    workflow.nodes.forEach((node) => {
      if (node.type === NodeType.End || node.type === NodeType.AssignCampaign) return;

      if (CONDITIONAL_TYPES.has(node.type)) {
        if (node.childrenNodes.length < 2) hasMissingBranch = true;
      } else if (node.childrenNodes.length === 0) {
        hasNoChild = true;
      }
    });

    if (hasNoChild) errors.push('NO_CHILD_NODE');
    if (hasMissingBranch) errors.push('CONDITIONAL_MISSING_BRANCH');

    return errors;
  }
  shouldValidate(workflow: IWorkflow): boolean {
    return workflow.type === WorkflowType.DRIP || workflow.type === WorkflowType.PILL;
  }
}
